import { Controller } from "stimulus";

export default class extends Controller {

    initialize() {
        this.ready =
            import ( /* webpackChunkName: 'tui-editor' */ '../assets/tui-editor')
            .then(({ default: Editor }) => Editor);
    }

    async connect() {
        if (this.element.nodeName !== 'TEXTAREA') {
            return;
        }
        const Editor = await this.ready;
        this.wrapper = document.createElement('div');
        this.element.after(this.wrapper);
        const options = {
            el: this.wrapper,
            height: Math.max(300, this.element.offsetHeight || 0) + 'px',
            initialEditType: 'wysiwyg',
            usageStatistics: false,
            initialValue: this.element.value,
            toolbarItems: [
                ['heading', 'bold', 'italic', 'link']
            ], // TODO: Hier können weitere toolbar-Items notwendig werden (https://nhn.github.io/tui.editor/latest/tutorial-example19-customizing-toolbar-buttons)
            hideModeSwitch: true,
            autofocus: false
        }
        this.element.style.display = 'none';
        this.editor = new Editor(options);
        this.editor.on('change', () => { this.element.value = this.editor.getMarkdown() });
    }

    disconnect() {
        this.element.style.display = '';
        this.wrapper.parentNode.removeChild(this.wrapper);
    }
}
